// src/features/properties/PropertyEditForm.js

import React, { useState, useEffect, useRef } from 'react'
import PhoneTagInput from '../utils/PhoneTagInput'
import districtsData from '../districts-tphcm.json'
import { useUpdatePropertyMutation, useCheckPhoneExistsQuery } from './PropertiesApiSlice'
import useAuth from '../../hooks/useAuth'
import { Modal } from 'react-bootstrap'
import uploadToCloudinary from '../utils/cloudinaryUpload';
import CloudinaryImage from '../utils/CloudinaryImage';
import getPublicId from '../utils/getPublicId';

// Hàm upload ảnh lên Cloudinary (copy từ Welcome.js)

const PropertyEditForm = ({ property, onSuccess, onCancel, onDuplicateFound, onViewOldProperty }) => {
    const { username, isAdmin, userId } = useAuth()
    const [updateProperty] = useUpdatePropertyMutation()

    const [isSubmitting, setIsSubmitting] = useState(false)
    const [showPhoneExistsModal, setShowPhoneExistsModal] = useState(false)
    const [phoneToCheck, setPhoneToCheck] = useState('')

    const hiddenPasteInput = useRef(null)
    const fileInputMobileRef = useRef(null)
    const { data: isPhoneExisted = false, isFetching: checkingPhone } = useCheckPhoneExistsQuery(
        phoneToCheck ? { phone: phoneToCheck, excludeId: property?._id } : null,
        { skip: !phoneToCheck || phoneToCheck.length < 9 }
    )

    useEffect(() => {
        if (isPhoneExisted && phoneToCheck && !checkingPhone) {
            setShowPhoneExistsModal(true)
        }
    }, [isPhoneExisted, phoneToCheck, checkingPhone])

    const [formData, setFormData] = useState({
        id: '',
        phone: [],
        ownerName: '',
        ownerType: 'Chủ nhà',
        houseNumber: '',
        street: '',
        oldDistrict: '',
        oldWard: '',
        newWard: '',
        propertyType: 'Nhà phố',
        width: '',
        length: '',
        floorArea: '',
        totalArea: '',
        floors: '',
        price: '',
        position: 'Mặt tiền',
        description: '',
        status: 'Đang cho thuê',
        images: [],
        imageUrls: [],
        updatedBy: username
    })

    const fileInputRef = useRef(null)
    const [imagesToDelete, setImagesToDelete] = useState([])

    // const uploadToCloudinary = async (files) => {
    //     if (!files || files.length === 0) return []

    //     const uploadedImages = [] // ← mảng object { url, public_id }
    //     const uploadPreset = 'realestate-upload'
    //     const cloudName = 'dp9lxlric'

    //     for (const file of files) {
    //         const formData = new FormData()
    //         formData.append('file', file)
    //         formData.append('upload_preset', uploadPreset)
    //         formData.append('folder', 'properties') // giữ nguyên thư mục

    //         try {
    //             const res = await fetch(
    //                 `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`,
    //                 {
    //                     method: 'POST',
    //                     body: formData
    //                 }
    //             )

    //             const data = await res.json()

    //             if (data.secure_url && data.public_id) {
    //                 uploadedImages.push({
    //                     url: data.secure_url,
    //                     public_id: data.public_id  // ← QUAN TRỌNG: dùng để xóa sau này
    //                 })
    //             } else {
    //                 console.error('Upload thất bại, không có secure_url:', data)
    //                 // Không return null → vẫn tiếp tục upload các ảnh khác
    //             }
    //         } catch (err) {
    //             console.error('Lỗi mạng khi upload ảnh:', err)
    //             // Không break → vẫn cố upload ảnh còn lại
    //         }
    //     }

    //     return uploadedImages // ← Trả về: [{ url: "...", public_id: "properties/abc123" }, ...]
    // }

    const removeExistingImage = (index) => {
        const img = formData.imageUrls[index]
        
        // Ghi nhớ public_id để xóa sau khi lưu
        if (img.public_id) {
            setImagesToDelete(prev => [...prev, img.public_id])
        }

        // Chỉ xóa khỏi giao diện
        setFormData(prev => ({
            ...prev,
            imageUrls: prev.imageUrls.filter((_, i) => i !== index)
        }))
    }

    const handlePhoneExistAction = (action) => {
        setShowPhoneExistsModal(false)
        setPhoneToCheck('')
        if (action === 'view' && onViewOldProperty) {
            onViewOldProperty(phoneToCheck)
        }
    }

    // Load dữ liệu khi mở
    useEffect(() => {
        if (property) {
            setFormData({
                id: property._id,
                phone: property.phone || [],
                ownerName: property.ownerName || '',
                ownerType: property.ownerType || 'Chủ nhà',
                houseNumber: property.houseNumber || '',
                street: property.street || '',
                oldDistrict: property.oldDistrict || '',
                oldWard: property.oldWard || '',
                newWard: property.newWard || '',
                propertyType: property.propertyType || 'Nhà phố',
                width: property.width || '',
                length: property.length || '',
                floorArea: property.floorArea || '',
                totalArea: property.totalArea || '',
                floors: property.floors || '',
                price: property.price || '',
                position: property.position || 'Mặt tiền',
                description: property.description || '',
                status: property.status || 'Đang cho thuê',
                images: [],
                imageUrls: property.images || [],
                updatedBy: username
            })
        }
    }, [property, username])

    // Xử lý input
    const handleInputChange = (e) => {
        const { name, value } = e.target
        setFormData(prev => ({
            ...prev,
            [name]: value,
            ...(name === 'oldDistrict' && { oldWard: '', newWard: '' })
        }))
    }

    const handleImageChange = (e) => {
        const files = Array.from(e.target.files)
        setFormData(prev => ({ ...prev, images: [...prev.images, ...files] }))
    }

    const removeImage = (index) => {
        setFormData(prev => ({
            ...prev,
            images: prev.images.filter((_, i) => i !== index)
        }))
    }

    const handleForceSubmit = () => {
        setShowPhoneExistsModal(false)
        setPhoneToCheck('')
    }

    const handleSubmit = async () => {
        if (!formData.phone.length || !formData.street || !formData.oldDistrict) {
            alert('Vui lòng điền đầy đủ các trường có dấu (*)')
            return
        }

        setIsSubmitting(true)

        try {

            // let finalImageUrls = [...formData.imageUrls]
            // // Upload ảnh mới
            // if (formData.images.length > 0) {
            //     const uploaded = await uploadToCloudinary(formData.images)
            //     if (!uploaded || uploaded.length === 0) {
            //         alert('Upload ảnh mới thất bại!')
            //         return
            //     }
            //     finalImageUrls = [...finalImageUrls, ...uploaded]
            // }

            let finalImageObjects = [...formData.imageUrls];  // cũ: có url + public_id

            if (formData.images.length > 0) {
                const uploaded = await uploadToCloudinary(formData.images);
                finalImageObjects = [...finalImageObjects, ...uploaded];
            }

            await updateProperty({
                id: formData.id,
                phone: finalPhones,//formData.phone,
                ownerName: formData.ownerName.trim(),
                ownerType: formData.ownerType,
                houseNumber: formData.houseNumber?.trim() || '',
                street: formData.street.trim(),
                oldDistrict: formData.oldDistrict,
                oldWard: formData.oldWard || '',
                newWard: formData.newWard || '',
                propertyType: formData.propertyType,
                width: formData.width ? Number(formData.width) : null,
                length: formData.length ? Number(formData.length) : null,
                floorArea: formData.floorArea ? Number(formData.floorArea) : null,
                totalArea: formData.totalArea ? Number(formData.totalArea) : null,
                floors: formData.floors ? Number(formData.floors) : null,
                price: formData.price ? Number(formData.price) : null,
                position: formData.position,
                description: formData.description?.trim() || '',
                status: formData.status,
                images: finalImageObjects,
                // images: finalImageUrls,
                imagesToDelete: imagesToDelete,
                updatedBy: username
            }).unwrap()

            onSuccess() // quay lại chế độ chi tiết
        } catch (err) {
            alert('Lỗi khi cập nhật: ' + (err?.data?.message || 'Không xác định'))
        } finally {
            setIsSubmitting(false)
        }
    }

    const selectedOldWards = formData.oldDistrict ? districtsData[formData.oldDistrict]?.old || [] : []
    const selectedNewWards = formData.oldDistrict ? districtsData[formData.oldDistrict]?.new || [] : []

    const [inputPhone, setInputPhone] = useState("");
    const [newAddedPhones, setNewAddedPhones] = useState([]); // chỉ lưu số mới thêm trong phiên này

    const addPhoneForSale = () => {
        let phone = inputPhone.trim().replace(/[^\d]/g, "");
        if (!phone) return;

        if (phone.startsWith("84")) phone = "0" + phone.slice(2);

        if (phone.length < 9 || phone.length > 11) {
            alert("SĐT không hợp lệ");
            return;
        }

        if (formData.phone.includes(phone) || newAddedPhones.includes(phone)) {
            alert("Số này đã có rồi");
            setInputPhone("");
            return;
        }

        setNewAddedPhones([...newAddedPhones, phone]);
        setInputPhone("");
    };

    const removeNewPhone = (phone) => {
        setNewAddedPhones(newAddedPhones.filter(p => p !== phone));
    };

    // Khi submit: gộp số cũ + số mới thêm
    const finalPhones = [...formData.phone, ...newAddedPhones];

    const handlePasteImage = async (e) => {
        const items = e.clipboardData?.items;

        if (!items || items.length === 0) return;

        for (const item of items) {
            if (item.type.startsWith("image/")) {
                const blob = item.getAsFile();
                if (!blob) return;

                // Đổi tên file cho dễ quản lý
                const file = new File([blob], `pasted-${Date.now()}.png`, { type: "image/png" });

                // Thêm vào formData.images (giống như chọn file thủ công)
                setFormData(prev => ({
                    ...prev,
                    images: [...prev.images, file]
                }));
            }
        }
    };
    const handleSmartPaste = async () => {
        try {
            // 1. Thử đọc clipboard (chỉ hoạt động trên HTTPS hoặc localhost)
            const clipboardItems = await navigator.clipboard.read()
            let hasImage = false

            for (const item of clipboardItems) {
                for (const type of item.types) {
                    if (type.startsWith('image/')) {
                        hasImage = true
                        const blob = await item.getType(type)
                        const file = new File([blob], `pasted-${Date.now()}.png`, { type: blob.type })
                        
                        setFormData(prev => ({
                            ...prev,
                            images: [...prev.images, file]
                        }))
                        return
                    }
                }
            }

            // 2. Nếu không có ảnh trong clipboard → mở thư viện
            if (!hasImage) {
                fileInputMobileRef.current?.click()
            }

        } catch (err) {
            // 3. Nếu trình duyệt chặn clipboard (rất hay xảy ra trên mobile)
            console.log('Clipboard API bị chặn, chuyển sang cách thủ công')
            hiddenPasteInput.current?.focus()
        }
    }
    return (
        <>
            <Modal.Body className="bg-dark text-white" style={{ maxHeight: '75vh', overflowY: 'auto' }}>
                <div className="row g-3">

                    {/* 1. Số điện thoại (bắt buộc) */}
                    <div className="col-12 col-md-6">
                        {/* <PhoneTagInput
                            value={formData.phone}
                            onChange={(phones) => setFormData(prev => ({ ...prev, phone: phones }))}
                            onDuplicateFound={(phone) => setPhoneToCheck(phone)}
                        /> */}

                        {isAdmin ? (
                            // ADMIN: thấy hết, xóa được, thêm được
                            <PhoneTagInput
                                value={formData.phone}
                                onChange={(newPhones) => setFormData({ ...formData, phone: newPhones })}
                            />
                        ) : (
                            // SALE: chỉ được thêm, không thấy danh sách cũ, không xóa được
                            <div>
                                <label className="form-label fw-semibold">
                                    Số điện thoại <span className="text-danger">*</span>
                                </label>

                                <div className="input-group">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Nhập SĐT mới để thêm..."
                                        value={inputPhone}
                                        onChange={(e) => setInputPhone(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                                e.preventDefault();
                                                addPhoneForSale();
                                            }
                                        }}
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-outline-success"
                                        onClick={addPhoneForSale}
                                    >
                                        Thêm số mới
                                    </button>
                                    
                                    <div className="d-block mb-2">
                                        <small className="text-info">
                                            <i className="bi bi-shield-lock me-1"></i>
                                            Đã có <strong>{formData.phone.length} số điện thoại</strong> (chỉ Admin mới xem được)
                                        </small>
                                    </div>
                                </div>

                                {/* Hiển thị các số mới thêm trong phiên này */}
                                {newAddedPhones.length > 0 && (
                                    <div className="mt-2 d-flex flex-wrap gap-2">
                                        {newAddedPhones.map((phone) => (
                                            <span key={phone} className="badge bg-success text-white p-2">
                                                {phone} (mới thêm)
                                                <button
                                                    type="button"
                                                    className="btn-close btn-close-white ms-2"
                                                    style={{ fontSize: "0.7rem" }}
                                                    onClick={() => removeNewPhone(phone)}
                                                />
                                            </span>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    
                    {/* 2. Tên chủ nhà */}
                    <div className="col-12 col-md-6">
                        <label className="form-label">Tên chủ nhà</label>
                        <input
                            type="text"
                            name="ownerName"
                            className="form-control"
                            value={formData.ownerName}
                            onChange={handleInputChange}
                        />
                    </div>
                    
                    {/* 3. Loại chủ */}
                    <div className="col-12 col-md-6">
                        <label className="form-label">Loại chủ</label>
                        <select
                            name="ownerType"
                            className="form-select"
                            value={formData.ownerType}
                            onChange={handleInputChange}
                        >
                            <option>Chủ nhà</option>
                            <option>Đầu tư</option>
                            <option>Môi giới</option>
                        </select>
                    </div>

                    {/* 4. Số nhà */}
                    <div className="col-12 col-md-6">
                        <label className="form-label">Số nhà</label>
                        <input
                            type="text"
                            name="houseNumber"
                            className="form-control"
                            value={formData.houseNumber}
                            onChange={handleInputChange}
                            placeholder="Ví dụ: 123, 45A, 67/89..."
                        />
                    </div>

                    {/* 5. Tên đường (bắt buộc) */}
                    <div className="col-12">
                        <label className="form-label">
                            Tên đường <span className="text-danger">*</span>
                        </label>
                        <input
                            type="text"
                            name="street"
                            className="form-control"
                            value={formData.street}
                            onChange={handleInputChange}
                            placeholder="Ví dụ: Nguyễn Văn Cừ, Lê Văn Sỹ..."
                            required
                        />
                    </div>

                    {/* 6. Quận cũ (bắt buộc) */}
                    <div className="col-12 col-md-4">
                        <label className="form-label">
                            Quận/huyện cũ <span className="text-danger">*</span>
                        </label>
                        <select
                            name="oldDistrict"
                            className="form-select"
                            value={formData.oldDistrict}
                            onChange={handleInputChange}
                            required
                        >
                            <option value="">Chọn quận/huyện</option>
                            {Object.keys(districtsData).map(d => (
                                <option key={d} value={d}>{d}</option>
                            ))}
                        </select>
                    </div>

                    {/* 7. Phường cũ */}
                    <div className="col-12 col-md-4">
                        <label className="form-label">Phường cũ</label>
                        <select
                            name="oldWard"
                            className="form-select"
                            value={formData.oldWard}
                            onChange={handleInputChange}
                            disabled={!formData.oldDistrict}
                        >
                            <option value="">Chọn phường cũ</option>
                            {selectedOldWards.map((ward, i) => (
                                <option key={i} value={ward}>{ward}</option>
                            ))}
                        </select>
                    </div>

                    {/* 8. Phường mới */}
                    <div className="col-12 col-md-4">
                        <label className="form-label">Phường mới</label>
                        <select
                            name="newWard"
                            className="form-select"
                            value={formData.newWard}
                            onChange={handleInputChange}
                            disabled={!formData.oldDistrict}
                        >
                            <option value="">Chọn phường mới</option>
                            {selectedNewWards.map((ward, i) => (
                                <option key={i} value={ward}>{ward}</option>
                            ))}
                        </select>
                    </div>

                    {/* 9. Loại nhà */}
                    <div className="col-12 col-md-6">
                        <label className="form-label">Loại nhà</label>
                        <select
                            name="propertyType"
                            className="form-select"
                            value={formData.propertyType}
                            onChange={handleInputChange}
                        >
                            <option>Nhà phố</option>
                            <option>Biệt thự</option>
                            <option>Toà nhà văn phòng</option>
                            <option>Đất trống</option>
                            <option>Kho xưởng</option>
                        </select>
                    </div>

                    {/* 10. Vị trí */}
                    <div className="col-12 col-md-6">
                        <label className="form-label">Vị trí</label>
                        <select
                            name="position"
                            className="form-select"
                            value={formData.position}
                            onChange={handleInputChange}
                        >
                            <option>Mặt tiền</option>
                            <option>Mặt tiền hẻm</option>
                            <option>2 mặt tiền</option>
                            <option>3 mặt tiền</option>
                        </select>
                    </div>

                    {/* 11-16. Các trường số */}
                    <div className="col-12 col-md-4">
                        <label className="form-label">Bề ngang (m)</label>
                        <input type="number" name="width" className="form-control" value={formData.width} onChange={handleInputChange} placeholder="Ví dụ: 5" />
                    </div>
                    <div className="col-12 col-md-4">
                        <label className="form-label">Chiều dài (m)</label>
                        <input type="number" name="length" className="form-control" value={formData.length} onChange={handleInputChange} placeholder="Ví dụ: 20" />
                    </div>
                    <div className="col-12 col-md-4">
                        <label className="form-label">Diện tích sàn (m²)</label>
                        <input type="number" name="floorArea" className="form-control" value={formData.floorArea} onChange={handleInputChange} />
                    </div>
                    <div className="col-12 col-md-4">
                        <label className="form-label">Tổng diện tích sàn (m²)</label>
                        <input type="number" name="totalArea" className="form-control" value={formData.totalArea} onChange={handleInputChange} />
                    </div>
                    <div className="col-12 col-md-4">
                        <label className="form-label">Số tầng</label>
                        <input type="number" name="floors" className="form-control" value={formData.floors} onChange={handleInputChange} min="1" />
                    </div>
                    <div className="col-12 col-md-4">
                        <label className="form-label">Giá thuê (VNĐ)</label>
                        <input type="number" name="price" className="form-control" value={formData.price} onChange={handleInputChange} placeholder="Triệu/tháng" />
                    </div>

                    {/* 17. Mô tả */}
                    <div className="col-12">
                        <label className="form-label">Mô tả</label>
                        <textarea
                            name="description"
                            className="form-control"
                            rows="5"
                            value={formData.description}
                            onChange={handleInputChange}
                            placeholder="Nhà mới đẹp, hướng Đông, hẻm xe hơi, gần trường học..."
                        ></textarea>
                    </div>
                    {/* Các field còn lại copy từ form Thêm mới vào đây, chỉ đổi onChange={handleInputChange} */}

                    {/* 18. Hình ảnh */}
                    <div className="col-12">
                        <label className="form-label">Ảnh hiện tại ({formData.imageUrls.length})</label>
                        <div className="mt-3 row g-3">
                            {formData.imageUrls.map((img, i) => {
                                const publicId = getPublicId(img);  // ← hỗ trợ cả cũ và mới
                                const fallbackUrl = img.url || null; // chỉ dùng nếu publicId lỗi (hiếm)

                                return publicId ? (
                                    <div key={i} className="col-6 col-md-4 col-lg-3 position-relative">
                                        <CloudinaryImage
                                            publicId={publicId}
                                            height={140}
                                            crop="fill"
                                            alt={`Hình hiện tại ${i + 1}`}
                                            className="img-fluid rounded shadow-sm"
                                            style={{ height: '140px', objectFit: 'cover' }}
                                            fallbackUrl={fallbackUrl}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-danger btn-sm rounded-circle position-absolute top-0 end-0 m-2"
                                            style={{ width: '32px', height: '32px' }}
                                            onClick={() => removeExistingImage(i)}
                                        >
                                            x
                                        </button>
                                    </div>
                                ) : null;
                            })}
                        </div>

                        <label className="form-label">Hình ảnh</label>
                        <input
                            type="file"
                            className="form-control"
                            multiple
                            accept="image/*"
                            onChange={handleImageChange}
                        />
                        <div className="border p-3 bg-secondary bg-opacity-10 rounded text-center">
                            <p className="text-info small mb-3">
                                (Copy ảnh trước → bấm nút hoặc CTRL+V → tự động dán)
                            </p>

                            <div className="d-flex flex-column gap-3 align-items-center">
                                {/* Nút chính – siêu thông minh */}
                                <button
                                    type="button"
                                    className="btn btn-primary  shadow-sm"
                                    onClick={handleSmartPaste}
                                    style={{ fontSize: '1.1rem' }}
                                >
                                    <i className="bi bi-clipboard2-plus-fill me-2 fs-4"></i>
                                    Dán ảnh ngay
                                </button>

                                {/* Input ẩn để bắt paste thủ công */}
                                <input
                                    ref={hiddenPasteInput}
                                    type="text"
                                    readOnly
                                    style={{ position: 'absolute', left: '-9999px' }}
                                    onPaste={handlePasteImage}
                                />

                                {/* Input mở thư viện ảnh khi không dán được */}
                                <input
                                    ref={fileInputMobileRef}
                                    type="file"
                                    accept="image/*"
                                    multiple
                                    className="d-none"
                                    onChange={handleImageChange}
                                />
                            </div>
                        </div>
                        <div className="mt-3 row g-3">
                            {formData.images.map((img, i) => (
                                <div key={i} className="col-6 col-md-4 col-lg-3 position-relative">
                                    <img
                                        src={URL.createObjectURL(img)}
                                        alt={`Hình ${i + 1}`}
                                        className="img-fluid rounded shadow-sm"
                                        style={{ height: '140px', objectFit: 'cover' }}
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-danger btn-sm rounded-circle position-absolute top-0 end-0 m-2"
                                        onClick={() => removeImage(i)}
                                        style={{ width: '32px', height: '32px' }}
                                    >
                                        ×
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* 19. Trạng thái */}
                    <div className="col-12 col-md-6">
                        <label className="form-label">Trạng thái</label>
                        <select
                            name="status"
                            className="form-select"
                            value={formData.status}
                            onChange={handleInputChange}
                        >
                            <option>Đang cho thuê</option>
                            <option>Đã cho thuê</option>
                            <option>Đã bán</option>
                        </select>
                    </div>

                    {/* THÔNG TIN HỆ THỐNG */}
                    <div className="col-12 border-top pt-4 mt-4">
                        <div className="row text-info">
                            <div className="col-12 col-md-6">
                                <small><strong>Người tạo:</strong> {property.createdBy || 'N/A'}</small><br/>
                                <small><strong>Ngày tạo:</strong> {new Date(property.createdAt).toLocaleString('vi-VN')}</small>
                            </div>
                            <div className="col-12 col-md-6 text-md-end text-warning">
                                <small><strong>Người sửa cuối:</strong> {username}</small><br/>
                                <small><strong>Thời gian:</strong> {new Date().toLocaleString('vi-VN')}</small>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer className="bg-dark border-0">
                <button className="btn btn-secondary px-4" onClick={onCancel} disabled={isSubmitting}>
                    Hủy
                </button>
                <button
                    className="btn btn-warning px-5 d-flex align-items-center gap-2"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                >
                    {isSubmitting ? (
                        <>
                            <span className="spinner-border spinner-border-sm"></span>
                            Đang cập nhật...
                        </>
                    ) : (
                        'Cập nhật'
                    )}
                </button>
            </Modal.Footer>
            {/* Loading overlay */}
            {isSubmitting && (
                <div className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-black bg-opacity-50" style={{ zIndex: 9999 }}>
                    <div className="bg-dark p-5 rounded-4 text-center shadow">
                        <div className="spinner-border text-warning" style={{ width: '4rem', height: '4rem' }}></div>
                        <h4 className="mt-4 text-white">Đang lưu thay đổi...</h4>
                    </div>
                </div>
            )}

            {/* Modal SĐT đã tồn tại */}
            {showPhoneExistsModal && (
                <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 1060 }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content bg-dark text-white">
                            <div className="modal-body text-center">
                                <i className="bi bi-exclamation-triangle text-warning fs-1"></i>
                                <h5 className="mt-3">Số điện thoại đã tồn tại!</h5>
                                <p>Số <strong>{phoneToCheck}</strong> đã được dùng cho bất động sản khác, bạn muốn:</p>
                            </div>
                            <div className="modal-footer border-0 justify-content-center gap-3">
                                <button className="btn btn-light px-4" onClick={handleForceSubmit}>
                                    Vẫn cập nhật
                                </button>
                                <button className="btn btn-warning px-4" onClick={() => handlePhoneExistAction('view')}>
                                    Xem tin cũ
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default PropertyEditForm